module.exports = __webpack_public_path__ + "images/modern-2-10dd3e034ff97a8601e6faa7af83db13.jpg";